import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { IEcosystemCategory, IResourceData } from 'types/interfaces';
import { daoCategoryMock, daoResourceMock } from 'mockedData/daoTools.page';

export const ResourcesApi = {
    getResourcesData: (categoryId?: string): Promise<AxiosResponse<IResourceData[]>> => {
      const data = categoryId
      ? daoResourceMock.filter((r) => r.category_id === Number(categoryId))
      : daoResourceMock;

      return Promise.resolve({
        data: data,
        status: 200,
        statusText: "OK",
        headers: {},
        config: {},
        request: {},
      })
    },
        //axiosInstance.get<IResourceData[]>(`ecosystem-resource${categoryId ? '/sort?cat=' + categoryId : ''}`),
    getResourcesCategoriesData: (): Promise<AxiosResponse<any[]>> =>
        //axiosInstance.get<IEcosystemCategory[]>('ecosystem-category'),
        Promise.resolve({
          data: daoCategoryMock,
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
        }),
};
